// export const environment = {
//   production: true,
//   apiUrl: 'https://nirgroup.testnir.ru',
//   clientId: 2,
//   clientSecret: 'iqt55TXiXIkIiuUfZ8xnW5CQzOsnKllLebes9sN1',
//   project: null,
//   licence: 'ZL0ZKY9GSZDV',
//   defaultLocale: 'ru'
// };
export const environment = {
    production: true,
    apiUrl: 'https://api-rrms.testnir.ru',
    clientId: 2,
    clientSecret: 'TVJgJ3tohJszmQutuq2atcpUkMY3uFaYQhUwFiKX',
    project: null,
    licence: 'RY3LWPER6VDD',
    defaultLocale: 'ru'
};